import {enumIsEnumValue, FocalPoint, Values} from "@wix/devzai-utils-common";
import {WixMediaResource, wixMediaResourceGetFocalPoint} from "@wix/devzai-common-wix";

/**
 * Auto-resolve focal point from the media resource metadata.
 * Use explicit {x, y} values to override per-context (e.g., different crops for thumbnails vs banners).
 */
export const WixMediaViewAutoFocalPoint = {
    FromMediaIfAvailable: 'FromMediaIfAvailable',
} as const;

export type WixMediaViewAutoFocalPoint = Values<typeof WixMediaViewAutoFocalPoint>;

/**
 * Focal point options:
 * - `FocalPoint`: Explicit {x, y} coordinates (overrides media's focal point)
 * - `FromMediaIfAvailable`: Extract from media metadata if available
 * - `null`: No focal point, use default positioning
 */
export type WixMediaViewFocalPoint = FocalPoint | WixMediaViewAutoFocalPoint | null;

export function wixMediaViewFocalPointResolveForWixMediaResource(
    wixMediaViewFocalPoint: WixMediaViewFocalPoint,
    wixMediaResource: WixMediaResource
) : FocalPoint | null {
    if (enumIsEnumValue(WixMediaViewAutoFocalPoint, wixMediaViewFocalPoint)) {
        switch (wixMediaViewFocalPoint) {
            case WixMediaViewAutoFocalPoint.FromMediaIfAvailable: {
                return wixMediaResourceGetFocalPoint(wixMediaResource);
            }
        }
    } else {
        return wixMediaViewFocalPoint;
    }
}